import { useMemo } from 'react';

import { type Treatment } from '@spotify/confidence-editor-react';
import { useWorkflowInstanceContext } from '@spotify/plugin-confidence-workflows-react';

export type TreatmentsData = {
  treatments: Treatment[];
};

export const useTreatmentsData = (): TreatmentsData => {
  const { moduleData2 } = useWorkflowInstanceContext();

  const treatments = useMemo(() => {
    const abTestTreatments = moduleData2?.abtest?.treatments ?? [];

    return abTestTreatments.map(t => ({
      name: t.name ?? '',
      displayName: t.displayName ?? undefined,
      description: t.description ?? undefined,
      imageUri: t.imageUri ?? undefined,
      weight: t.weight ?? undefined,
    }));
  }, [moduleData2?.abtest?.treatments]);

  return { treatments };
};
